import axios from 'axios'

export const getEnergyUrl = contactId => `/api/rest/recording/media/energy/${contactId}`

export default {
  async getAudioEnergy(contactId, duration, dataPoints, offset, isRootRecording) {
    const params = {
      dataPoints,
      offset,
      duration,
    }

    if (isRootRecording) {
      params.isRootRecording = 'true'
    }

    const url = getEnergyUrl(contactId)
    try {
      const response = await axios.get(url, { params })
      return response.data
    } catch (error) {
      throw new Error(error)
    }
  },
}
